import { useTranslation } from "react-i18next";
import { useGlobal } from "reactn";
import { MediaQuery } from "@outplayed/responsive";
import { SummonerSpell } from "@outplayed/tooltips";
import { getPercetange, numberWithCommas } from "@ugg/shared/utils/math";
import { OverviewInfo } from "@ugg/shared/api/data-parser/champions/overview";

interface SummonerSpellsProps {
  recSummonerSpells: OverviewInfo["rec_summoner_spells"];
}

export default function SummonerSpells(props: SummonerSpellsProps) {
  const { t } = useTranslation();
  const [language] = useGlobal("language");
  const { recSummonerSpells } = props;

  return (
    <div className="content-section_content summoner-spells">
      <div className="content-section_header">
        <div>{t("Summoner Spells")}</div>
        {recSummonerSpells && (
          <div className="wr-matches">
            <span className={"win-rate"}>{`${getPercetange(recSummonerSpells.wins, recSummonerSpells.matches, 2)}% WR `}</span>
            <MediaQuery min="DESKTOP_MEDIUM" max="DESKTOP_LARGE">
              <span className="matches">{`(${numberWithCommas(recSummonerSpells.matches)} Matches)`}</span>
            </MediaQuery>
          </div>
        )}
      </div>
      <div className="flex">
        {recSummonerSpells && recSummonerSpells?.ids[0] > 0 && (
          <SummonerSpell spellId={recSummonerSpells.ids[0]} ssr language={language} webp />
        )}
        {recSummonerSpells && recSummonerSpells?.ids[1] > 0 && (
          <SummonerSpell spellId={recSummonerSpells.ids[1]} ssr language={language} webp />
        )}
      </div>
    </div>
  );
}
